/**
 * On-Demand FBAC (Funnelback AutoComplete) Script Loader
 * Dynamically loads the vendor library only when user interaction (hover/focus/click) occurs.
 */

let fbacPromise = null;

export const loadFbacScript = () => {
    if (typeof window !== "undefined" && window.FBAC) {
        return Promise.resolve(window.FBAC);
    }

    if (fbacPromise) {
        return fbacPromise;
    }

    fbacPromise = new Promise((resolve, reject) => {
        const isLocal =
            typeof window !== "undefined" &&
            (window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1");

        const scriptUrl =
            (typeof window !== "undefined" && window.FBAC_SCRIPT_URL) ||
            (isLocal
                ? "/externals/fbac.js"
                : "https://www.woodgroup.com/__data/assets/git_bridge/0021/134463/fbac/latest/fbac.min.latest.js");

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = scriptUrl;

        script.onload = () => {
            if (typeof window !== "undefined" && window.FBAC) {
                resolve(window.FBAC);
            } else {
                reject(new Error("FBAC script loaded but window.FBAC is undefined"));
            }
        };

        script.onerror = (err) => {
            fbacPromise = null; // Allow retry on subsequent attempts
            reject(err);
        };

        document.head.appendChild(script);
    });

    return fbacPromise;
};

export default loadFbacScript;
